"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("@/views/business/clientManage/customerPointsManagement/api");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FudouTransferLog',
  data: function data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: {
        customerId: '',
        page: 1,
        limit: 10,
        oldPhone: '',
        newPhone: '',
        operator: ''
      },
      dialog: {
        visible: false,
        previewLoading: false,
        confirmLoading: false,
        preview: null,
        previewParams: null,
        form: {
          oldPhone: '',
          newPhone: '',
          customerId: ''
        }
      },
      customerId: '',
      customerInfo: {}
    };
  },
  /*   created() {
      this.initCustomerId();
    }, */
  watch: {
    // 关键点：防止“再次进入但组件未销毁”
    '$route.query.customerInfo': {
      handler: function handler(val) {
        if (val && _typeof(val) === 'object') {
          // 存入本地存储
          sessionStorage.setItem('temp_customer_info', JSON.stringify(val));
          this.customerInfo = val;
        } else {
          // 刷新后从本地存储读取
          var saved = sessionStorage.getItem('temp_customer_info');
          if (saved) this.customerInfo = JSON.parse(saved);
        }
        this.initCustomerId();
      },
      immediate: true
    }
  },
  computed: {
    canConfirmTransfer: function canConfirmTransfer() {
      return Boolean(this.dialog.preview && this.isSameTransferParams(this.dialog.previewParams, this.buildTransferParams()));
    },
    previewTable: function previewTable() {
      if (!this.dialog.preview) return [];
      var p = this.dialog.preview;
      return [{
        label: '转移前总福豆',
        old: p.old_total_before,
        new: p.new_total_before
      }, {
        label: '转移前剩余福豆',
        old: p.old_remain_before,
        new: p.new_remain_before
      }, {
        label: '转移后总福豆',
        old: p.old_total_after,
        new: p.new_total_after
      }, {
        label: '转移后剩余福豆',
        old: p.old_remain_after,
        new: p.new_remain_after
      }];
    }
  },
  methods: {
    buildTransferParams: function buildTransferParams() {
      return {
        oldPhone: (this.dialog.form.oldPhone || '').trim(),
        newPhone: (this.dialog.form.newPhone || '').trim(),
        customerId: this.query.customerId
      };
    },
    isSameTransferParams: function isSameTransferParams(left, right) {
      return Boolean(left && right && left.oldPhone === right.oldPhone && left.newPhone === right.newPhone && left.customerId === right.customerId);
    },
    invalidatePreview: function invalidatePreview() {
      this.dialog.preview = null;
      this.dialog.previewParams = null;
    },
    handlePreview: function handlePreview() {
      var _this = this;
      var params = this.buildTransferParams();
      this.dialog.form = _objectSpread({}, params);
      this.invalidatePreview();
      if (!params.oldPhone || !params.newPhone) {
        this.$message.warning('请输入旧手机号和新手机号');
        return;
      }
      if (params.oldPhone === params.newPhone) {
        this.$message.warning('新旧手机号不能相同');
        return;
      }
      this.dialog.previewLoading = true;
      (0, _api.fudouConvertTips)(params).then(function (res) {
        // 请求期间手机号发生变化时，丢弃已经过期的预览结果
        if (!_this.isSameTransferParams(params, _this.buildTransferParams())) {
          return;
        }
        _this.dialog.preview = res;
        _this.dialog.previewParams = params;
      }).finally(function () {
        _this.dialog.previewLoading = false;
      });
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      var params = this.buildTransferParams();
      if (!this.dialog.preview || !this.isSameTransferParams(this.dialog.previewParams, params)) {
        this.$message.warning('手机号已修改，请重新点击确认获取转移预览');
        return;
      }
      this.$confirm('确认执行福豆转移？该操作不可撤销', '二次确认', {
        type: 'warning'
      }).then(function () {
        if (!_this2.isSameTransferParams(_this2.dialog.previewParams, _this2.buildTransferParams())) {
          _this2.invalidatePreview();
          _this2.$message.warning('手机号已修改，请重新点击确认获取转移预览');
          return;
        }
        _this2.dialog.confirmLoading = true;
        (0, _api.fudouConvert)(params).then(function () {
          _this2.$message.success('福豆转移成功');
          _this2.dialog.visible = false;
          _this2.fetchList(); // 刷新列表
        }).finally(function () {
          _this2.dialog.confirmLoading = false;
        });
      });
    },
    handleConvertFudou: function handleConvertFudou() {
      this.dialog.visible = true;
      this.invalidatePreview();
      this.dialog.form = {
        oldPhone: '',
        newPhone: '',
        customerId: ''
      };
    },
    initCustomerId: function initCustomerId() {
      var customerId = this.customerInfo.customerId;
      var customerInfo = this.customerInfo;
      if (!customerId) {
        //this.$message.error('缺少 customer_id');
        return;
      }
      this.customerId = customerId;
      this.customerInfo = customerInfo;
      this.query.customerId = customerId;
      this.fetchList();
    },
    fetchList: function fetchList() {
      var _this3 = this;
      this.loading = true;
      (0, _api.fudouTransferLogList)(this.query).then(function (res) {
        _this3.list = res.list || [];
        _this3.total = res.total || 0;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.query.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.query = {
        customerId: this.customerId,
        page: 1,
        limit: 10,
        oldPhone: '',
        newPhone: '',
        operator: ''
      };
      this.fetchList();
    },
    handlePageChange: function handlePageChange(page) {
      this.query.page = page;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.query.page = 1;
      this.query.limit = size;
      this.fetchList();
    }
  }
};